module.exports = __webpack_public_path__ + "static/media/hot_1.7378a647.png";